import { theme } from '@by-miles/bymiles-styles'
import styled from 'styled-components'

export const ExtrasStyles = styled.div`
  @media (min-width: ${theme.grid.resolution.tablet.width}px) {
    display: flex;
    gap: ${theme.grid.spacing.s}px;
  }
`
